import {
  LIVE_AGENT_LABELS,
  ORDER_SUBSCRIBE_VALUE,
  LIVE_AGENT_HANDOFF_VALUE,
} from '../constants/businessActions';

const LIVE_AGENT_LABEL_VARIANTS = [
  ...LIVE_AGENT_LABELS,
  'chat',
  'chat with a live agent',
  'chat with human',
  'talk to a human',
  'talk with a human',
  'human support',
  'talk to support',
  'talk to a live agent',
  'chat with support',
  'chat with a human',
];

const LIVE_AGENT_HIDDEN_ACTION_VALUES = [
  ...LIVE_AGENT_LABEL_VARIANTS,
  'subscribe',
  'subscribe now',
  'subscribe me',
  'newsletter',
  'sign up',
  ORDER_SUBSCRIBE_VALUE,
  LIVE_AGENT_HANDOFF_VALUE,
];

const BUBBLE_OPTION_HIDDEN_VALUES = [
  ...LIVE_AGENT_HIDDEN_ACTION_VALUES,
  'chat',
  'chat bubble',
  'chatbot',
  'chat bot',
];

export const normalizeActionValue = (value?: string): string =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_\/-]+/g, ' ')
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

const buildActionSet = (values: string[]): Set<string> =>
  new Set(values.map(value => normalizeActionValue(value)));

export const HIDDEN_ACTION_VALUES = buildActionSet([
  ...LIVE_AGENT_HIDDEN_ACTION_VALUES,
  'chat with support',
  'chat with a human',
]);
export const HIDDEN_SUGGESTED_ACTIONS = buildActionSet(LIVE_AGENT_HIDDEN_ACTION_VALUES);
export const HIDDEN_BUBBLE_ACTIONS = buildActionSet(BUBBLE_OPTION_HIDDEN_VALUES);

export const isHiddenAction = (value?: string): boolean =>
  HIDDEN_ACTION_VALUES.has(normalizeActionValue(value));

export const isHiddenSuggestedAction = (value?: string): boolean =>
  HIDDEN_SUGGESTED_ACTIONS.has(normalizeActionValue(value));

export const isHiddenBubbleOption = (value?: string): boolean =>
  HIDDEN_BUBBLE_ACTIONS.has(normalizeActionValue(value));

export const isReorderLikeAction = (label = '', value = ''): boolean => {
  const normalizedLabel = normalizeActionValue(label);
  const normalizedValue = normalizeActionValue(value);
  return (
    /reorder/.test(normalizedLabel) ||
    /buy\s+again/.test(normalizedLabel) ||
    /reorder/.test(normalizedValue) ||
    /buy\s+again/.test(normalizedValue)
  );
};
